module.exports = __webpack_public_path__ + "static/media/ap_pelvis_zone1.495b6c87.png";